export enum areas {
  MY_AREA,
  WORK_AREA,
  SETTINGS_AREA,
  MULTI_USER_MY_AREA,
  MULTI_USER_ADMIN_AREA,
}
